/* eslint-disable react-hooks/exhaustive-deps */
import { Typography } from '@material-ui/core';
import Spinner from 'common/components/spinner/spinner';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getListByUserId, setLoading } from './giveawayNumbersActions';


export function GiveawayNumbers(props) {
  useEffect(() => {
    props.getListByUserId(props.auth.user.id);
  }, []);
  if (props.giveawayNumbers.loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '92%', backgroundColor: 'transparent' }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <section
      id="giveawayNumbers-list"
      style={{ backgroundColor: 'transparent', height: '100vh' }}
    >
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '92vh', backgroundColor: 'transparent' }}
      >
        <Typography variant="h6">
          A disponibilização dos números da sorte no site ocorrerá até o dia
          01/02/2023, às 16h.
        </Typography>
      </div>
    </section>
  );

}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    giveawayNumbers: state.giveawayNumbers,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListByUserId,
      setLoading,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(GiveawayNumbers);
